import Login from './Login';
import Register from './Register';
export { Register };
export default Login;
